import { type TaskUserAttributes } from './generated/TaskUserAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface TaskUser extends TaskUserAttributes {}

@model
class TaskUser extends ApplicationModel {
  // Start auto-generated
  static typename: 'TaskUser' = 'TaskUser';
  get typename(): 'TaskUser' {
    return 'TaskUser';
  }

  static internalTypename: 'TaskUser' = 'TaskUser';
  get internalTypename(): 'TaskUser' {
    return 'TaskUser';
  }

  static fields = {
    completedDate: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    status: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    assignee: attr.belongsTo({
      readable: true,
      typename: ['Project', 'Responsibility', 'User'],
    }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    task: attr.belongsTo({ readable: true, typename: 'Task' }),
    user: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default TaskUser;
